export default {
  确认: "确认",
  取消: "取消",
  选择语言: "选择语言",
  切换语言成功: "切换语言成功",
  首页: "首页",
  报单: "报单",
  团队: "团队",
  "交易进行中,请勿进行其他操作": "交易进行中,请勿进行其他操作",
  资金管理: "资金管理",
  资金明细: "资金明细",
  我的订单: "我的订单",
  订单详情: "订单详情",
  没有更多了: "没有更多了",
  加载中: "加载中",
  代币价格: "代币价格",
  收益概览: "收益概览",
  申购收益: "申购收益",
  分享收益: "分享收益",
  官方网站: "官方网站",
  官网: "官网",
  电报: "电报",
  推特: "推特",
  白皮书: "白皮书",
  申购金额: "申购金额",
  请输入入金金额: "请输入入金金额",
  快捷申购: "快捷申购",
  申购比例: "申购比例",
  赠币数量: "赠币数量",
  立即申购: "立即申购",
  更多: "更多",
  订单: "订单",
  分红中: "分红中",
  已完成: "已完成",
  累计分红: "累计分红",
  申购信息: "申购信息",
  兑换数量: "兑换数量",
  赠币数量: "赠币数量",
  开始时间: "开始时间",
  提现成功: "提现成功",
  确认: "确认",
  订单编号: "订单编号",
  团队数据总览: "团队数据总览",
  我的推广链接: "我的推广链接",
  复制: "复制",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "分享此链接邀请好友加入团队，获取推广奖励",
  团队业绩: "团队业绩",
  当前等级: "当前等级",
  今日收益: "今日收益",
  申购收益: "申购收益",
  分享收益: "分享收益",
  团队用户: "团队用户",
  有效团队: "有效团队",
  有效用户: "有效用户",
  无效团队: "无效团队",
  直推用户: "直推用户",
  有效直推: "有效直推",
  无效直推: "无效直推",
  资产余额数据概览: "资产余额数据概览",
  提现: "提现",
  选中币种: "选中币种",
  请输入入金金额: "请输入入金金额",
  提现数量: "提现数量",
  确认提现: "确认提现",
  资金明细: "资金明细",
  分红收入: "分红收入",
  直推奖励: "直推奖励",
  团队奖励: "团队奖励",
  申购金额: "申购金额",
  兑换数量: "兑换数量",
  赠币数量: "赠币数量",
  开始时间: "开始时间",
  立即申购: "立即申购",
  确认: "确认",
  全部: "全部",
  收入: "收入",
  支出: "支出",
  请输入正确的金额: "请输入正确的金额",
  申购成功: "申购成功",
  申购失败: "申购失败",
  提现失败: "提现失败",
  提现信息: "提现信息",
  提现币种: "提现币种",
  提现数量: "提现数量",
  请选择币种: "请选择币种",
  钱包余额不足: "钱包余额不足",
  余额不足: "余额不足",
  提现手续费: "提现手续费",
  间推奖励: "间推奖励",
  团队奖励: "团队奖励",
  提现失败退还: "提现失败退还",
  ido申购: "ido申购",
  ido申购赠送: "ido申购赠送",
  链式去中心化全球点火网络: "链式去中心化全球点火网络",
  协议永生: "协议永生",
  智能涌现: "智能涌现",
  财富觉醒: "财富觉醒",
  立即进入: "立即进入",
  大区累计业绩: "大区累计业绩",
  小区累计业绩: "小区累计业绩",
  复制成功: "复制成功",
  复制失败: "复制失败",
  暂无数据: "暂无数据",
  当DeFi遇上自主型DAO: "当DeFi遇上自主型DAO",
  历史最高: "历史最高",
  历史最低: "历史最低",
  当前价格: "当前价格",
  报单累计收益: "报单累计收益",
  团队累计收益: "团队累计收益",
  报单金额: "报单金额",
  快捷报单: "快捷报单",
  请输入报单金额: "请输入报单金额",
  报单比例: "报单比例",
  报单信息: "报单信息",
  进行中: "进行中",
  已完成: "已完成",
  累计收益: "累计收益",
  立即报单: "立即报单",
  请输入提现数量: "请输入提现数量",
  提现确认: "提现确认",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除",
  "操作后无法撤销，请谨慎认购": "操作后无法撤销，请谨慎认购",
  我再想想: "我再想想",
  确认提现: "确认提现",
  余额不足: "余额不足",
  直推奖励: "直推奖励",
  团队奖励: "团队奖励",
  提现失败退还: "提现失败退还",
  平级收益: "平级收益",
  每日释放: "每日释放",
  提现JCT: "提现JCT",
  报单失败: "报单失败",
  绑定邀请人: "绑定邀请人",
  报单成功: "报单成功",
  提现比例: "提现比例",
  入金支付说明: "入金支付说明",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "您的实际支付由两部分组成，根据当前支付比例计算",
  支付JCT数量: "支付JCT数量",
  入金数量: "入金数量",
  JCT支付比例: "JCT支付比例",
  "注：支付比例由平台设定，可能随时调整":
    "注：支付比例由平台设定，可能随时调整",
  我知道了: "我知道了",
  支付USDT数量: "支付USDT数量",
  USDT支付比例: "USDT支付比例",
  JCT实时价格: "JCT实时价格",
  请先连接TCC链: "请先连接TCC链",
  CUSD支付比例: "CUSD支付比例",
  支付CUSD数量: "支付CUSD数量",
  算力红利: "算力红利",
  "当DeFi遇上自主型DAO闲置算力共享": "当DeFi遇上自主型DAO闲置算力共享",
  "全民节点分红智能涌现": "全民节点分红智能涌现",
  "闲置算力共享·全民节点分红": "闲置算力共享·全民节点分红",
  节点并网收益统计: "节点并网收益统计",
  算力资产入网收益台账: "算力资产入网收益台账",
  算力集群运维收益汇总: "算力集群运维收益汇总",
};
